import { gridState } from '@/features/rundown/grid/grid.store'

import type { Editor } from '@tiptap/core'

/**
 * Runs when tiptap editor mounts and checks for paste content.
 *
 * @remarks
 *   We create and dispatch native paste event, as methods like
 *   setContent() / insertContent() might bypass tiptap's
 *   paste pipeline (parsing, paste rules, etc.)
 */
export function handlePendingPaste(editor: Editor) {
  const pending = gridState.editor.pendingPaste

  if (!pending) return false

  editor.commands.focus()

  editor.commands.selectAll() // Paste replaces existing content

  const dataTransfer = new DataTransfer()

  const { html, text } = pending

  if (html) dataTransfer.setData('text/html', html)
  if (text) dataTransfer.setData('text/plain', text)

  const pasteEvent = new ClipboardEvent('paste', {
    clipboardData: dataTransfer,
    bubbles: true,
    cancelable: true,
  })

  editor.view.dom.dispatchEvent(pasteEvent)

  gridState.editor.pendingPaste = null // Reset state
}
